import { ListeHomeNotification } from 'src/graphql/generated-types';
import { ApplicationMessage, SubNotificationType } from 'src/app/_shared/stores/home/home.state';

const stateName = '[Home] ';

export class HomeGetNotificationsListAction {
    static readonly type = stateName + 'GetNotificationsList';
}

export class HomeSetNotificationAction {
    static readonly type = stateName + 'SetNotification';

    constructor(public notification: ListeHomeNotification) {
    }
}

export class HomeCloseNotificationAction {
    static readonly type = stateName + 'CloseNotification';
}

export class HomeSetSubNotificationTypeAction {
    static readonly type = stateName + 'SetSubNotificationType';

    constructor(public subNotificationType: SubNotificationType = null) {
    }
}

export class HomeGetApplicationMessagesListAction {
    static readonly type = stateName + 'GetApplicationMessageList';
}

export class HomeSetApplicationMessageAction {
    static readonly type = stateName + 'SetApplicationMessage';

    constructor(public message: ApplicationMessage) {
    }
}
